<template>
    <div v-clickaway="close">
        <div class="app-sidenav__notification-parent" @click="open()">
            <common-icon class="app-sidenav__notification-parent--icon" name="bell" size="huge"></common-icon>
            <div v-if="notificationCount" class="app-sidenav__notification-parent--amount">
                {{ notificationCount }}
            </div>
        </div>
        <common-dropdown
            :isOpen="isOpen"
            bgColor="gray"
            class="app-sidenav__notification--dropdown"
            :hasArrow="false"
            arrowPositionX="bottom"
            arrowPositionY="left"
        >
            <div
                v-for="(notification, index) in notifications"
                :key="index"
                :class="getClass(notification)"
                @click="goToProfile(notification)"
            >
                <p class="app-sidenav__notification--dropdown--row--text">
                    {{ $t('modals.notifications.new_member_near_by') }}
                    <br />
                    <b>{{ notification.data.heading }}</b>
                </p>
            </div>
            <div v-if="!notifications.length" class="app-sidenav__notification--dropdown--row">
                <p>{{ $t('modals.notifications.no_notifications') }}</p>
            </div>
        </common-dropdown>
    </div>
</template>

<script>
    import NotificationAPI from 'api/NotificationAPI'
    import Store from '~/store'

    export default {
        data() {
            return {
                isOpen: false,
                notifications: [],
            }
        },

        computed: {
            notificationCount() {
                return this.$auth.getActiveMember().notificationCount
            },
        },

        methods: {
            getClass(notification) {
                return {
                    'app-sidenav__notification--dropdown--row': true,
                    'app-sidenav__notification--dropdown--row--unread': !notification.isSeen,
                }
            },
            close() {
                this.isOpen = false
            },
            open() {
                this.getNotifications()
                this.isOpen = !this.isOpen
            },
            async goToProfile(notification) {
                if (notification.notificationType === 'CRE_CONSTRAINT_NOTIFICATION' || notification.data?.actionId) {
                    try {
                        await NotificationAPI.reportCreMessageAnswered(notification.id)
                    } catch (err) {
                        console.error('[CRE] in-app message answered failed', err)
                    }
                }

                if (notification.data?.link) {
                    this.$router.push({ path: notification.data.link })
                }
                this.close()
            },

            getNotifications() {
                const activeMemberId = this.$auth.getActiveMember().id

                NotificationAPI.getNotifications(activeMemberId).then((resp) => {
                    this.notifications = resp
                })
                const activeMembers = this.$auth.getMembers()
                const member = activeMembers.find((member) => member.id === activeMemberId)
                member.notificationCount = 0
                Store.dispatch('auth/setMembers', activeMembers)
            },
        },
    }
</script>
